import React from 'react';
import PropTypes from 'prop-types';

import ClientStatusView from './ClientStatusView';
import ClientStatusEdit from './ClientStatusEdit';

const ClientStatus = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientData,
    clientBackend,
  } = props;

  return (
    <>
      <ClientStatusView
        clientData={clientData}
        clientBackend={clientBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <ClientStatusEdit
          clientData={clientData}
          clientBackend={clientBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

ClientStatus.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientStatus);
